export interface ISignInRequestData {
  email: string;
  password: string;
}

export interface IPhoneRequestOTPData {
  phone: string;
  code: number;
}

export interface IVerifyPhoneData extends IPhoneRequestOTPData {
  otp: string;
}

export interface ISignUpRequestData extends ISignInRequestData {}

export enum LandingKey {
  BINGO = 'bingo',
  DIRECT_EM = 'direct_em',
  DIRECT_REG = 'direct_reg',
  DIRECT_SU = 'direct_su',
  FOOTBALL_PROMO = 'football-promo-2026',
  SOCIAL = 'soc',
}
